import { useQuery } from "@tanstack/react-query";
import { gql } from "../api/graphql.js";
import { EMAIL_ACCOUNTS_QUERY } from "../api/queries.js";

export interface EmailAccount {
  id: string;
  display_name: string;
  protocol: string;
  folders_to_scan: string[];
  default_company_id: string | null;
}

interface Resp {
  email_accounts: EmailAccount[];
}

export function useEmailAccounts() {
  return useQuery({
    queryKey: ["email_accounts"],
    queryFn: async () => {
      const data = await gql.request<Resp>(EMAIL_ACCOUNTS_QUERY);
      return data.email_accounts;
    },
  });
}
